export function treeMap() {
    let treeMapData;
    let colorIndex = 0;
    let treeMapDataSecond;
    let tooltipSettings = {
        titleStyle: {
            "color": "#1D2328",
            "font-size": "12px",
            "font-weight": "600",
            "text-align": "center",
            "opacity": "0",
            "visibility": "hidden"
        },
        background: function () {
            return "#fff";
        },
        width: function () {
            return "120px";
        },
        body: function value(d) {
            return d.SumOfTotalEquity;
        },
        bodyStyle: {
            "color": "#1D2328",
            "font-size": "12px",
            "font-weight": "600",
            "text-align": "center",
        },
        tbody: {
            0: {
                0() {
                    return false;
                },
            }
        }
    };
    let nav = ".treemap-nav";
    let isInitSecondInstance = false;
    let sliderContainer = $(".treemap-slider");
    let treeMapcontainer = $(".treemap-slide");
    let colors = ["#264C68", "#007395", "#34C8DB", "#567E9B", "#309ABA", "#87DEE9"];

    let addColor = function (arrayData, id) {

        arrayData.map((item, index) => {
            if (colorIndex > 5) {
                colorIndex = 0;
            }
            item.SumOfTotalEquity = item[arrayData.columns[1]].replace(/[\s.,%]/g, "");
            item.color = colors[colorIndex];
            colorIndex++;

            if (item[id] === "Grand Total") {
                removePartOfData(arrayData,index);
            }
        });
    };

    let removePartOfData = function (data,elIndex) {
        data.splice((elIndex),1);
    };

    $(document).ready(function () {
        $.ajax({
            type: "GET",
            url: $(treeMapcontainer[0]).attr("data-src"),
            dataType: "text",
            success: function (result) {

                if (result) {
                    treeMapData = d3.csvParse(result);

                    addColor(treeMapData, "MSA");

                    new d3plus.Treemap()
                        .data(treeMapData)
                        .groupBy("MSA")
                        .select(treeMapcontainer[0])
                        .sum(d => d.SumOfTotalEquity)
                        .legend(false)
                        .color((d, i) => {
                            if (d.color) {
                                return d.color;
                            }
                        })
                        .label((d) => {
                            return d["MSA"] + ",";
                        })
                        .shapeConfig({
                            labelConfig: {
                                fontColor() {
                                    return "#fff";
                                },
                                fontMax: 20,
                                verticalAlign: "bottom",
                            }
                        })
                        .tooltipConfig(tooltipSettings)
                        .render();
                }
            }
        });

        $.ajax({
            type: "GET",
            url: $(treeMapcontainer[1]).attr("data-src"),
            dataType: "text",
            success: function (result) {
                if (result) {
                    treeMapDataSecond = d3.csvParse(result);

                    addColor(treeMapDataSecond,"Asset Type");

                    new d3plus.Treemap()
                        .data(treeMapDataSecond)
                        .groupBy("Asset Type")
                        .select(treeMapcontainer[1])
                        .sum(d => d.SumOfTotalEquity)
                        .legend(false)
                        .color((d, i) => {
                            if (d.color) {
                                return d.color;
                            }
                        })
                        .label((d) => {
                            return d["Asset Type"] + ",";
                        })
                        .shapeConfig({
                            labelConfig: {
                                fontColor() {
                                    return "#fff";
                                },
                                fontMax: 20,
                                verticalAlign: "bottom",
                            },
                        })
                        .tooltipConfig(tooltipSettings)
                        .render();
                }
            }
        });

        sliderContainer.slick({
            arrows: true,
            prevArrow: "<button class='prev ocean-prev'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.24625 0L0.24625 6L6.24625 12L7.75 10.5L3.24625 6L7.75 1.5L6.24625 0Z' fill='white'/></svg></button>",
            nextArrow: "<button class='next ocean-right'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M1.75375 0L7.75375 6L1.75375 12L0.25 10.5L4.75375 6L0.25 1.5L1.75375 0Z' fill='white'/></svg></button>",
            dots: true,
            mobileFirst: true,
            slidesToShow: 1,
            infinite: false,
            appendArrows: nav,
            appendDots: nav,
        });

        sliderContainer.on("afterChange", function (event, slick, currentSlide) {
            if (currentSlide === 1 && !isInitSecondInstance) {
                $(window).scrollTop($(window).scrollTop() + 1);
                isInitSecondInstance = true;
            }
        });

        treeMapcontainer.each((index, item) => {
            $(item).css({
                width: ""
            });
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/treeMap.js